import azFlag from "../../assets/img/az_flag.png";
import type { FlagVariant } from "../../i18n/types";

interface FlagCircleProps {
  variant?: FlagVariant;
  stripes: [string, string, string];
  className?: string;
}

function UnionJackIcon() {
  return (
    <svg
      viewBox="0 0 60 60"
      className="h-full w-full"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <rect width="60" height="60" fill="#012169" />
      <polygon points="0,0 10,0 60,50 60,60 50,60 0,10" fill="#fff" />
      <polygon points="60,0 60,10 10,60 0,60 0,50 50,0" fill="#fff" />
      <rect x="24" y="0" width="12" height="60" fill="#fff" />
      <rect x="0" y="24" width="60" height="12" fill="#fff" />
      <polygon points="0,0 6,0 60,54 60,60 54,60 0,6" fill="#c8102e" />
      <polygon points="60,0 60,6 6,60 0,60 0,54 54,0" fill="#c8102e" />
      <rect x="26" y="0" width="8" height="60" fill="#c8102e" />
      <rect x="0" y="26" width="60" height="8" fill="#c8102e" />
    </svg>
  );
}

function FlagCircle({
  variant = "tricolor",
  stripes,
  className = "",
}: FlagCircleProps) {
  const shellClass = `relative inline-flex h-6 w-6 shrink-0 overflow-hidden rounded-full border border-white/30 ${className}`;

  if (variant === "union-jack") {
    return (
      <span className={shellClass} aria-hidden data-testid="flag-union-jack">
        <UnionJackIcon />
      </span>
    );
  }

  if (variant === "azerbaijan") {
    return (
      <span className={shellClass} aria-hidden data-testid="flag-azerbaijan">
        <img
          src={azFlag}
          alt=""
          className="h-full w-full object-cover object-center"
        />
      </span>
    );
  }

  return (
    <span className={shellClass} aria-hidden>
      <span className="flex h-full w-full rotate-90 scale-[1.42]">
        {stripes.map((color, index) => (
          <span
            key={index}
            className="h-full flex-1"
            data-testid="flag-stripe"
            style={{ backgroundColor: color }}
          />
        ))}
      </span>
    </span>
  );
}

export default FlagCircle;
